import DndSortRoot from "./DndSort";
import DndSortCard from "./DndSortCard";
import DndSortZone from "./DndSortZone";

export const DndSort = Object.assign(DndSortRoot, {
  Card: DndSortCard,
  Zone: DndSortZone,
});
export { DndSortCard, DndSortZone };

export { type DndSortProps } from "./DndSort";
export { type DndSortCardProps } from "./DndSortCard";
export { type DndSortZoneProps } from "./DndSortZone";
export type { DndSortChangeEvent, DndSortZoneAdvancedRenderer } from "./types";
